function capitaliseFirst(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function listItemTitle(
    record: { title?: string | null; publicId?: string | null } | null,
    fallback: string,
): string {
    const title = record?.title?.trim();
    if (title) {
        return capitaliseFirst(title);
    }

    const publicId = record?.publicId?.trim();
    if (publicId) {
        return publicId;
    }

    return fallback;
}

export function listItemId(
    record: { publicId?: string | null } | null,
): string {
    return record?.publicId?.trim() ?? "";
}
